import { poe1 } from '../../game';
import { EndgameContent } from '../models/enums';
import { FavouriteCurrencyMode } from '../models/filter-models';

export interface EndgamePresetFavouriteCurrencyDef {
  content?: EndgameContent;
  itemTypes: string[];
  mode: FavouriteCurrencyMode;
  value: number | null;
  aggregate?: boolean;
}

export const ENDGAME_PRESET_FAVOURITE_CURRENCIES: EndgamePresetFavouriteCurrencyDef[] = poe1 ? [
  {
    content: EndgameContent.Sanctum,
    itemTypes: ['Sanctum Research'],
    mode: FavouriteCurrencyMode.PromoteTier,
    value: 2,
  },
] : [
  {
    content: EndgameContent.SekhemasTrial,
    itemTypes: ['Trial Coins'],
    mode: FavouriteCurrencyMode.PromoteTier,
    value: 2,
  },
  {
    content: EndgameContent.ChaosTrial,
    itemTypes: ['Ultimatums'],
    mode: FavouriteCurrencyMode.PromoteTier,
    value: 2,
  },
  {
    itemTypes: [],
    mode: FavouriteCurrencyMode.Multiplier,
    value: 2,
    aggregate: true,
  },
];
